<template>
  <div class="ui-box-item">
    <titleComponents :show.sync="show" name="黄疸监测"></titleComponents>
    <div class="itemInfo-detail" v-show="show">
      <table class="ui-box-table">
        <tr>
          <th>测量时间</th>
          <th>测量部位</th>
          <th>参考数值</th>
          <th>测量数值</th>
          <th>测量结果</th>
        </tr>
        <tr v-if="!isToDay">
          <td>今日暂无</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr v-for="item in data.jaundiceDevices" :key="item.tbId">
          <td>{{item.createTime}}</td>
          <td>{{positionMap[item.tbMeasurePosition]}}</td>
          <td>{{Number(item.referValue)+'mg/dl'}}</td>
          <td>{{Number(item.tbJaundiceValue)+'mg/dl'}}</td>
          <td>{{item.tbState}}</td>
        </tr>
      </table>
      <div class="footer">
        <el-button type="primary" @click="toJaundiceList" v-has="pathCode+':toJaundiceList'">查看全部</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import titleComponents from '@/components/mother/title'
export default {
  name: 'jaundiceInfo',
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    pathCode: String
  },
  data () {
    return {
      positionList: [
        { id: 0, name: '无' },
        { id: 1, name: '额头' },
        { id: 2, name: '脸颊' },
        { id: 3, name: '胸部' },
      ],
      show: true
    }
  },
  computed: {
    positionMap () {
      return this.positionList.reduce((res, { id, name }) => {
        res[id] = name
        return res
      }, {})
    },
    isToDay () {
      if (this.data?.jaundiceDevices?.length > 0) {
        const time = this.data?.jaundiceDevices[0].createTime
        return new Date().toDateString() === new Date(time).toDateString()
      }
      return false
    },
    ...mapGetters(['lastBreadCrumb', 'refreshPage'])
  },
  created () {

  },
  methods: {
    toJaundiceList () {
      this.openTab('黄疸数据', 'jaundice', `/monitor/jaundice`, { phone: this.data.phone })
    }
  },
  components: {
    titleComponents
  }
}
</script>

<style lang="scss" scoped>
.ui-box-item {
  margin: 20px 24px 0;
  background: rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  width: calc(100% - 48px);
  .itemInfo-detail {
    border-top: 1px solid #e5e5e5;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    .footer {
      margin-top: 20px;
      width: 100%;
      text-align: right;
    }
    .ui-box-table {
      table-layout: fixed;
      text-align: center;
      width: 100%;
      border: 1px solid #d8d8d8;
      border-radius: 6px;
      border-collapse: collapse;
      border-style: hidden;
      box-shadow: 0 0 0 1px #e0e0e0;
      overflow: hidden;
      tr {
        border: 1px solid #e0e0e0;
        height: 54px;
        line-height: 54px;
        th {
          background: #ffffff;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 700;
          color: #000000;
          text-align: center;
          border: 1px solid #e0e0e0;
        }
        td {
          background: #ffffff;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          border: 1px solid #e0e0e0;
        }
      }
    }
  }
}
</style>
     